
import { toast } from 'sonner';

// Keys for tracking authentication state
const SIGNIN_TOAST_SHOWN_KEY = 'signin_toast_shown';
const LAST_SIGNIN_TIMESTAMP_KEY = 'last_signin_timestamp';
const SIGNIN_COOLDOWN_MS = 5000; // 5 seconds cooldown between toasts

export const handleAuthStateChange = (event: string, session: any) => {
  if (import.meta.env.DEV) {
    console.log('Auth state changed:', event, session?.user?.id);
  }
  
  if (event === 'SIGNED_IN' && session) {
    // Get current timestamp
    const now = Date.now();
    const lastSigninTimestamp = parseInt(sessionStorage.getItem(LAST_SIGNIN_TIMESTAMP_KEY) || '0');
    const timeSinceLastSignin = now - lastSigninTimestamp;
    
    // Check if this is a genuine new sign-in
    const isNewSignIn = sessionStorage.getItem('is_new_signin') === 'true';
    const isWithinCooldown = timeSinceLastSignin < SIGNIN_COOLDOWN_MS;
    
    // Only show toast for genuine new sign-ins that aren't within the cooldown period
    if (isNewSignIn && !isWithinCooldown) {
      toast.success('Successfully signed in!');
      sessionStorage.setItem(LAST_SIGNIN_TIMESTAMP_KEY, now.toString());
      sessionStorage.setItem(SIGNIN_TOAST_SHOWN_KEY, session.access_token);
    }
    
    // Always clear the new signin flag after processing
    sessionStorage.removeItem('is_new_signin');
  } else if (event === 'SIGNED_OUT') {
    // Clear all auth-related flags when signing out
    sessionStorage.removeItem(SIGNIN_TOAST_SHOWN_KEY);
    sessionStorage.removeItem(LAST_SIGNIN_TIMESTAMP_KEY);
    sessionStorage.removeItem('is_new_signin');
    toast.success('Successfully signed out!');
  } else if (event === 'PASSWORD_RECOVERY') {
    // Don't show a toast here — the ResetPasswordForm component handles the UI
    // The session is established automatically by Supabase for the password update
  } else if (event === 'USER_UPDATED') {
    // Don't show generic toast on password reset page — ResetPasswordForm handles its own feedback
    const isResetPage = typeof window !== 'undefined' && window.location.search.includes('mode=reset');
    if (!isResetPage) {
      toast.success('Your account has been updated.');
    }
  }
};

export const parseHashParams = () => {
  if (typeof window !== 'undefined' && window.location.hash) {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const error = hashParams.get('error');
    const errorDescription = hashParams.get('error_description');
    
    if (error) {
      toast.error(errorDescription || error);
    }
    
    const type = hashParams.get('type');
    if (type === 'recovery') {
      // This is a password reset flow, we don't need to do anything special here
      // The Auth component will handle displaying the reset password form
    } else if (type === 'signup' || type === 'invite' || type === 'magiclink') {
      // These are all types that result in a new sign-in
      sessionStorage.setItem('is_new_signin', 'true');
    }
  }
};
